export enum ExternalRoutesEnum {
    Jobs = 'https://jobs.inshared.nl',
}
